import React from 'react'

import SpendAccordionInvestPath from 'assets/icons/spend-accordion-invest.svg'
import SpendAccordionLaterPath from 'assets/icons/spend-accordion-later.svg'
import { withClickTrack } from 'components/Trackers/ClickTracker'
import { TRACKER_IDS } from 'components/Trackers/trackerIDs'
import { TestIDs } from 'test/utils/testIds'

import AccordionContent from './AccordionContent'
import { investAccordionContent, laterAccordionContent } from './content'
import {
  AccordionClickTracker,
  AccordionsContainer,
  AccordionsTitle,
  StyledBottomAccordion,
  StyledTopAccordion,
} from './styled-components'

const AccordionOne = withClickTrack<any, any>(TRACKER_IDS.SPEND_INTRO.ACCORDION_ONE)(
  AccordionClickTracker,
)

const AccordionTwo = withClickTrack<any, any>(TRACKER_IDS.SPEND_INTRO.ACCORDION_TWO)(
  AccordionClickTracker,
)

const Accordions: React.SFC = () => (
  <>
    <AccordionsTitle>Plus your investment and retirement accounts are built in:</AccordionsTitle>

    <AccordionsContainer>
      <AccordionOne>
        <StyledTopAccordion
          header={'Acorns Invest'}
          subheader={'Investment account'}
          imagePath={SpendAccordionInvestPath}
          dataTestId={TestIDs.WELCOME.SPEND.ACORNS_INVEST_ACCORDION}
        >
          {investAccordionContent.map((content, index) => (
            <AccordionContent key={index} header={content.header} text={content.text} />
          ))}
        </StyledTopAccordion>
      </AccordionOne>

      <AccordionTwo>
        <StyledBottomAccordion
          header={'Acorns Later'}
          subheader={'Retirement account'}
          imagePath={SpendAccordionLaterPath}
          dataTestId={TestIDs.WELCOME.SPEND.ACORNS_LATER_ACCORDION}
        >
          {laterAccordionContent.map((content, index) => (
            <AccordionContent key={index} header={content.header} text={content.text} />
          ))}
        </StyledBottomAccordion>
      </AccordionTwo>
    </AccordionsContainer>
  </>
)

export default Accordions
